import React, { useRef } from "react";
import { Icon } from "@/components/Icon";

/* SportsNavigation — the sport tiles row (design, README §2.5). All + Live + one
   tile per sport present on the board. Selected = white pill; the Live tile's icon
   and count are red. Horizontal scroll with a fade + scroll button on desktop,
   sticky scroller on mobile. Selecting a tile sets `sportFilter`; Live sets the
   live view. Sizes: 88×70 desktop, 80×66 tablet, 68×60 mobile. */

function Tile({ icon, label, count, active, live, onClick, testid }) {
  const accent = live ? "#EF4444" : active ? "#0A0A0A" : "#71717a";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="relative flex shrink-0 flex-col items-center justify-center gap-1 rounded-[14px] h-[60px] w-[68px] sm:h-[66px] sm:w-[80px] lg:h-[70px] lg:w-[88px] transition-colors"
      style={
        active
          ? { background: "#FAFAFA", boxShadow: "0 8px 20px rgba(0,0,0,.3)" }
          : { background: "#111114", boxShadow: "inset 0 0 0 1px #1F1F23, inset 0 1px 0 rgba(255,255,255,.05)" }
      }
    >
      {count != null && (
        <span
          className="absolute right-1.5 top-1 font-display font-extrabold tabular-nums"
          style={{ fontSize: 10, color: live ? "#EF4444" : active ? "#0A0A0A" : "#8A8A93" }}
        >{count}</span>
      )}
      <span style={{ width: 20, height: 20, background: accent, WebkitMask: `url(/icons/${icon}.svg) center/contain no-repeat`, mask: `url(/icons/${icon}.svg) center/contain no-repeat` }} />
      <span style={{ font: "600 13px Outfit", color: active ? "#0A0A0A" : "#D4D4D8" }}>{label}</span>
    </button>
  );
}

export default function SportsNavigation({ items, active, view, onPick, onAll, onLive, liveCount = 0, totalCount = 0 }) {
  const scroller = useRef(null);
  const page = () => { const el = scroller.current; if (el) el.scrollBy({ left: 280, behavior: "smooth" }); };
  return (
    <div className="relative">
      <div ref={scroller} className="no-scrollbar flex gap-2 overflow-x-auto pb-1 pr-10" data-testid="sport-filter">
        <Tile icon="all-sports" label="All" count={totalCount} active={active === "all" && view !== "live"} onClick={onAll} testid="view-all" />
        <Tile icon="live" label="Live" count={liveCount} live active={view === "live"} onClick={onLive} testid="view-live" />
        {items.map((s) => (
          <Tile key={s.id} icon={s.icon} label={s.label} count={s.count}
            active={active === s.id && view !== "live"} onClick={() => onPick(s.id)} testid={`filter-${s.id}`} />
        ))}
      </div>
      {/* desktop fade + scroll button */}
      <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-24 bg-gradient-to-l from-[#0A0A0A] to-transparent lg:block" />
      <button type="button" onClick={page} aria-label="Scroll sports"
        className="absolute right-0 top-1/2 hidden h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border border-[#26262B] bg-[#141417] text-[#a1a1aa] hover:text-white lg:flex">
        <Icon name="chevron-right" size={16} />
      </button>
    </div>
  );
}
